var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.comboBoxContainer},[_c('InputValidator',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.hideList),expression:"hideList"}],attrs:{"config":{
      label: _vm.control.label,
      name: _vm.control.label,
      validate: _vm.control.required ? 'required' : '',
      value: _vm.value,
    },"tooltip":_vm.getTooltip()},on:{"InputValidatorFocus":_vm.toggleDropDown,"InputValidatorModel":_vm.handleChange}}),_c('DropDownList',{attrs:{"classNames":_vm.classNames,"isLargeDropDown":false,"itemSection":"dynamic control combo","menuSections":_vm.getDisplayOptions(_vm.control),"menuFontSize":"small","showList":_vm.showList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }